import { Component } from '@angular/core';

@Component({
  selector: 'app-storefront-shimmer',
  templateUrl: './storefront-shimmer.component.html',
  styleUrls: ['./storefront-shimmer.component.scss'],
})
export class StorefrontShimmerComponent {
  trackByIndex(index: number, item: any): number {
    return index;
  }
}
